// Central registry of real, provided image assets.
// Any asset NOT listed here has not been provided yet and must render as an
// elegant PlaceholderMockup (see components/ui/PlaceholderMockup.tsx) instead
// of a generic stand-in image.

export const FULL_MOCKUP_URL =
  'https://cdn.magicpatterns.com/uploads/nfVwKJ36eYri3rLwJjoeEj/ChatGPT_Image_15_ago_2026__14_44_05__1_-removebg-preview.png';
